import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class CloudinaryService {

    private cloudName = 'dvvv508iq';
    private apiKey = '828384388329633';
    private uploadPreset = 'signatures';

    constructor(
        public auth: AuthService,
        private http: HttpClient
    ) {
    }

    async uploadImage(base64DataUrl: string, folder: any): Promise<string> {
        try {
            const formData = new FormData();
            formData.append('file', base64DataUrl);
            formData.append('upload_preset', this.uploadPreset);
            formData.append('folder', `${folder}`);

            // Usa resource_type auto para soportar imágenes y PDF
            const url = `https://api.cloudinary.com/v1_1/${this.cloudName}/auto/upload`;
            const response: any = await this.http.post(url, formData).toPromise();

            return response.secure_url;
        } catch (error) {
            console.error('Error al subir archivo a Cloudinary:', error);
            throw new Error('No se pudo subir el archivo.');
        }
    }
}